// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Ox5er","button--header--mob":"Button_button--header--mob__HDrWL","button--header":"Button_button--header__ZbKDb"};